import { FETCH_MORE_PRODUCTS_SUCCESS } from './../const';

export default (json) => {
  return {type: FETCH_MORE_PRODUCTS_SUCCESS, json}
};
